import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Input,
  SimpleChanges,
  OnChanges,
  OnInit,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-autocomplete',
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatDialogModule,
    MatSnackBarModule,
    MatRippleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatCardModule,
    MatChipsModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDividerModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    MatMenuModule,
    MatBadgeModule,
  ],
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.css'],
  standalone: true,
})
export class AutocompleteComponent implements OnInit, OnChanges {
  @Input() label: string;
  @Input() appearance?: string = 'outline';
  @Input() autocompleteControl?: FormControl;
  @Input() required: boolean = false;
  @Input() options: { name: string }[];
  @Input() optGroup?: { title: string; list: string[] } = {
    title: null,
    list: [],
  };
  @Input() errorStateMatcher: any;
  filteredOptions$: Observable<any[]>;
  isDropdownOpened: boolean = false;
  hasStartedTyping: boolean = false;

  constructor(private cd: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.options && this.options) {
      this.filteredOptions$ = this.autocompleteControl.valueChanges.pipe(
        startWith(''),
        map((value) => {
          if (this.isDropdownOpened && !this.hasStartedTyping) {
            return this.options; // Show all options when dropdown is open and typing hasn't started
          } else {
            return this._filter(value); // Apply filter when typing starts
          }
        })
      );
    }
  }

  ngOnInit() {
    this.cd.detectChanges();
  }

  private _filter(value: string): any[] {
    const filterValue = value?.toLowerCase();
    const filteredList = this.options.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );

    if (filteredList.length === 0) {
      // Return a special object to indicate no options found
      return [{ name: 'No options', disabled: true }];
    }

    return filteredList;
  }

  // Update the onDropdownOpen method
  onDropdownOpen() {
    this.isDropdownOpened = true;
  }

  // Update the onDropdownClose method
  onDropdownClose() {
    this.hasStartedTyping = false; // Reset on dropdown close
    this.autocompleteControl.updateValueAndValidity();
    this.isDropdownOpened = false;
  }

  // Update the onKeyup method
  onKeyup() {
    this.hasStartedTyping = true;
    this.autocompleteControl.updateValueAndValidity();
  }
}
